export default "__VITE_ASSET__nb2nlg6R__"